import React from "react";
import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";
import ProfileImage from "../../components/partials/ProfileImage";
import HttpServices from "../../utils/Http.services";
import { checkTextTranslation, checkTranslation, pathMaker, phoneStandardView } from "../../utils/useful";
import { Doughnut, Bar, Line, Pie, HorizontalBar } from 'react-chartjs-2';

import { saveAs } from 'file-saver';
import moment from "moment";
import DateInput from "../../components/inputs/DateInput";
import SelectInput from "../../components/inputs/SelectInput";
import Loader from 'react-loader-spinner'


class TimeGraphApplet extends React.Component {



    state = {
        filter: {},
        chartData: {
            labels: [],
            datasets: [
                {
                    label: 'Data',
                    data: [],
                    fill: false,
                    backgroundColor: [],
                    backgroundColor: [],
                    yAxisID: 'Amount',
                },
            ],
        },


        chartHorizontalOptions: {
            // indexAxis: 'y',
            responsive: true,
            // type: 'category',
            legend: {
                display: false,

            },

            scales: {
                xAxes: [
                    {
                        scaleFontSize: 10,
                        gridLines: {
                            display: true,
                            color: "#f0f2f4",
                            zeroLineColor: '#eee'
                        },
                        ticks: {
                            fontSize: 10
                        }
                    }
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: true,
                            color: "#f0f2f4",
                            zeroLineColor: '#eee'
                        },
                        ticks: {
                            beginAtZero: true,
                            fontSize: 10

                        }
                    }
                ]
            }

        },

        // lineChartOptions: {
        //     bezierCurve: false,
        //     legend: {
        //         display: false
        //     },

        //     scales: {
        //         xAxes: [
        //             {
        //                 gridLines: {
        //                     display: true,
        //                     color: "#f0f2f4",
        //                     zeroLineColor: '#bcd'
        //                 },
        //             }
        //         ],
        //         yAxes: [
        //             {
        //                 gridLines: {
        //                     display: true,
        //                     color: "#f0f2f4",
        //                     zeroLineColor: '#bcd'
        //                 },
        //                 ticks: {
        //                     beginAtZero: true
        //                 }
        //             }
        //         ]
        //     }
        // },

        lineChartOptions: {
            bezierCurve: true,
            legend: {
                display: false
            },
            responsive: true,
            elements: {
                line: {
                    tension: 2
                }
            },


            scales: {
                xAxes: [
                    {
                        type: "time",
                        time: {
                            unit: 'week',
                            displayFormats: {
                                hour: "MMM DD"
                            },
                            tooltipFormat: "MMM D"
                        },
                        gridLines: {
                            display: true,
                            color: "#f0f2f4",
                            zeroLineColor: '#bcd'
                        },
                        color: '#000'
                    }
                ],
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true,
                            color: "#f0f2f4",
                            zeroLineColor: '#bcd'
                        },
                    }

                ]
            }
        },


        chartOptions: {
            indexAxis: 'y',
            responsive: true,
            legend: {
                display: false
            },

            scales: {
                yAxes: [
                    {
                        gridLines: {
                            display: true,
                            color: "#f0f2f4",
                            zeroLineColor: '#bcd'
                        },
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                    },

                ],
            },
        },
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {


        if (this.props.page && (this.props.page?.key !== prevProps.page?.key)) {
            let now = new Date().getTime()
            console.log(now - this.lastInit)
            if (!this.lastInit || (now - this.lastInit > 1000)) {
                this.init()
            }
        }
    }


    init() {
        this.lastInit = new Date().getTime()
        console.log('INIT')
        if (this.props.page) {
            this.setState({ data: [], calanderData: {}, showCalendar: false, totalCount: null, filters: null }, () => {
                if (this.props.page.extraSelectDefault) {
                    let filter = this.state.filter
                    filter['extra'] = this.props.page.extraSelectDefault

                }
                // if(this.props.page.pageType != "calanderPage"){
                if (this.props.page.pageType = "timeGraph") {
                    if (!this.state.filter.startDate) {
                        this.changeDate('startDate', moment(new Date()).subtract(1, 'month').startOf('month').valueOf())
                        this.changeDate('endDate', moment(new Date()).endOf('month').valueOf())
                    }
                    if (this.props.page.pageType = "timeGraph") {
                        if (!this.state.timeType) {
                            this.setState({ timeType: 'week' })
                        }
                        if (!this.state.chartType) {
                            this.setState({ chartType: 'bar' })
                        }
                    }
                    // console.log("DKALJDJKLAD")
                    setTimeout(() => {
                        this.doSearch()
                    }, 300);
                }
            })
        }
    }

    doSearch = () => {
        // console.log("this.doSearch")
        this.fetch()
    }




    fetch = (filter, getCount) => {
        console.log("FETCH")
        this.setState({ isLoading: true })
        let body = this.props.page.filter ?? {}
        let page = this.props.page
        body.page = page.key
        body.limit = this.state.limit
        body.skip = this.state.currentPage

        body.filter = this.state.filter ?? {}

        if (this.props.page.settings && this.props.page.settings.fetchFilter) {
            body.filter = this.props.page.settings.fetchFilter
        }


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        if (filter) {
            body.filter = { ...body.filter, ...filter }
        }

        if (this.props.page.settings && this.props.page.settings.page) {
            body.page = this.props.page.settings.page
        }


        if (this.state.filter) {
            body.filter = { ...body.filter, ...this.state.filter }
        }

        if (this.props.page.sort) {
            body.sort = this.props.page.sort
        }

        if (this.props.page.populate) {
            body.populate = this.props.page.populate
        }

        console.log(page.fetchUrl)
        console.log(body)


        HttpServices.request(page.fetchUrl, body, (data, fetchError) => {
            this.setState({ isLoadingData: false })
            console.log(data)
            console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            this.setState({ isLoading: false })
            if (data.status == 200) {
                console.log(data)
                this.setState({ data: [] }, () => {
                    this.setState({
                        data: data.info,
                        showChart: false
                    })
                })

                if ((this.props.page.showChart || this.props.page.showHorizontalChart) && data.info.reportSummery) {
                    // console.log("HERE!")
                    let chartData = this.state.chartData
                    chartData.datasets = [{ data: [], backgroundColor: [], label: 'Amount', fill: false }]
                    chartData.labels = []
                    data.info.reportSummery.forEach(element => {
                        // if (element.title) {
                            chartData.labels.push(String(element.title).substring(0, 25) + (String(element.title).length > 25 ? ' ...' : ''))
                        // }
                        chartData.datasets[0].data.push(element.value)
                        chartData.datasets[0].backgroundColor.push(element.color ? element.color : "#677dc4")
                    })
                    this.setState({ showChart: true, chartData, reportSummery: data.info.reportSummery })

                }



                if (this.props.page.showTimeChart && data.info.graphData) {
                    // console.log("HERE2")
                    let chartData = this.state.chartData
                    chartData.datasets = [{ data: [], backgroundColor: '#42BECA', borderWidth: 4, borderRadius: 8, borderColor: '#42BECAdd', lineTension: 0.4, spanGaps: 0, label: 'Amount', fill: false }]
                    chartData.labels = []

                    this.makeChart(data.info.graphData)

                }


                if (data.count != null) {
                    this.setState({ totalCount: data.count })
                }
            }
        })
    }




    makeChart(data, type) {

        console.log(data)
        this.setState({ showTimeChart: false }, () => {

            this.groupData(data, this.state.timeType, (grouped) => {
                let chartData = {}
                chartData.datasets = [{ data: [], backgroundColor: '#677dc4', borderWidth: 4, borderRadius: 8, borderColor: '#677dc4', lineTension: 0.4, spanGaps: 0, label: 'Amount', fill: false }]
                chartData.labels = []

                Object.values(grouped).forEach(element => {
                    // if (moment([element._id.year, element._id.month, element._id.dayOfMonth]).valueOf()) {
                    // chartData.labels.push(moment([element._id.year, element._id.month, element._id.dayOfMonth]).valueOf())

                    chartData.labels.push(element.time)
                    chartData.datasets[0].data.push(element.count)
                    // }
                });

                this.setState({ showTimeChart: true, chartData, chartRawInfo: data })
            })
        })

    }


    groupData(data, type, cb) {

        if (type == 'day') {
            type = "dayOfMonth"
        }

        let keys = ['year', 'month', 'week', 'dayOfMonth']
        let dateKeys = ['YYYY', 'MM', 'W', 'DD']

        let keyIndex = keys.indexOf(type)
        // console.log(keyIndex)
        // console.log(type)
        let grouped = data.reduce(function (r, a) {
            let key = ''
            let timeKey = ''
            for (let i = 0; i < keyIndex + 1; i++) {
                const element = keys[i];
                // console.log(element)
                key = key + (i != 0 ? ' ' : '') + a._id[element]
                timeKey = timeKey + (i != 0 ? ' ' : '') + dateKeys[i]

            }
            //   console.log(key)
            //   console.log(timeKey)
            let time = moment(key, timeKey).valueOf()

            // let time = moment([a._id.year, (keyIndex > 1 ? a._id.month : 1), (keyIndex > 2 ? a._id.dayOfMonth : 1)])
            if (keyIndex == 2) {
                time = moment(a._id.year + " " + a._id.week, "YYYY W").valueOf()
            }
            // console.log(moment(a._id.year + " "+a._id.month +" "+ a._id.week, "YYYY MM W").valueOf())


            r[time] = r[time] || { count: 0, time: time }
            r[time].count = r[time].count + a.count
            // console.log(key)

            return r




            // r[a._id] = r[a.categoryInfo._id] || { value: 0, title: a.categoryInfo.values.name };
            // r[a.categoryInfo._id].value = r[a.categoryInfo._id].value + a.value;
            // return r;
        }, Object.create(null));

        // console.log(grouped)

        cb(grouped)

    }





    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            // this.fetchData()
        })
    }




    fetchExport = () => {

        HttpServices.request(this.props.page?.extra?.export?.url, {}, (fetchResult, fetchError) => {

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }

            saveAs(siteConfig.assetsDomain + fetchResult.info)

            this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })
    }




    filterLabelCreator(rawprop) {
        let prop = JSON.parse(JSON.stringify(rawprop))
        // console.log(prop)
        let isArray = false
        if (Array.isArray(prop.value)) {
            isArray = true
        }

        // let label
        let value = prop.value
        if (prop.type == 'PhoneInput') {
            value = phoneStandardView(value)
        }


        if (prop.dictionary) {

            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const element = value[i];
                    if (prop.dictionary[element]) {
                        value[i] = prop.dictionary[element]
                    }
                }
            } else {
                if (prop.dictionary[value]) {
                    value = prop.dictionary[value]
                }
            }
        }

        let label = checkTranslation(prop.label) + ' ' + prop.operator + ' ' + value


        return label
    }




    openOptions = (prop, index) => {
        // console.log(prop)

        let options = []

        Object.values(this.props.page?.extra).forEach(element => {
            let option = { ...element }
            option.function = this[option.function]
            options.push(option)
        });

        this.setState({ options, currentItem: prop, currentIndex: index }, () => {
            this.optionsModal.modal.showModal()
        })

    }

    openExport = () => {
        this.exportModal.showModal()
        this.fetchExport()
        // console.log("TEST")
    }



    changeDate = (key, date) => {
        let filter = this.state.filter
        filter[key] = date

        this.setState({ [key]: date, filter }, () => {

            // console.log(this.state.endDate)
            // console.log(this.state.startDate)
            if (this.state.endDate < this.state.startDate) {
                this.setState({ endDate: null })
            }
        })
    }


    extraSelectChange = (key, value) => {
        let filter = this.state.filter
        filter[key] = value
        // this.setState({ [key]: date }, () => {
        //   // console.log(this.state.endDate)
        //   // console.log(this.state.startDate)
        //   if (this.state.endDate < this.state.startDate) {
        //     this.setState({ endDate: null })
        //   }
        // })
        this.setState({ filter })
    }

    changeSelectValue = (key, value) => {
        this.setState({ [key]: value })
        let lineChartOptions = this.state.lineChartOptions
        lineChartOptions.scales.xAxes[0].time.unit = value
        console.log(value)
        this.setState({ lineChartOptions }, () => {
            this.makeChart(this.state.chartRawInfo, value)
        })

    }


    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation(this.props.page?.title), button: { goBack: false } }}
                title={checkTextTranslation(this.props.page?.title)}
                description={checkTextTranslation(this.props.page?.description)}
                className=""
            >

                <div className="container " >
                    <div className="row m-0">
                        <div className="col-12 p-0 mb-4" >
                            <div className="p-0" style={{ borderRadius: 0 }}>

                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                    <div className="flexc mt-2">

                                        <ProfileImage width={54} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image ?? this.props.page?.icon }} />

                                        <div>
                                            <p className="text-big font-bold m-0 " style={{ color: '#0d172a' }}>{this.props.page?.title}</p>
                                            <p className="text-small m-0" style={{ color: '#89a' }} >{this.state.totalCount ? (this.state.totalCount + " Records Found") : this.props.page?.description}</p>
                                        </div>
                                    </div>



                                </div>


                                {/* {this.state.filter && Object.values(this.state.filter).length > 0 && (
                                    <div className="flexc mt-2 px-1">
                                        {Object.values(this.state.filter).map((prop, index) => {
                                            return (
                                                <div key={index} className="flexcc mrd-1" style={{ backgroundColor: 'rgba(103, 125, 196, 0.082)', color: 'rgba(103, 125, 196, 0.8)', borderRadius: 20, padding: '3px 10px', fontSize: 12, }}>
                                                    {this.filterLabelCreator(prop)}
                                                    <button onClick={() => this.removeFilter(prop)} className="p-0 mld-2" style={{ color: 'rgba(103, 125, 196, 0.8)', fontSize: 12 }}>
                                                        <span className="flexcc">X</span>
                                                    </button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )} */}

                            </div>

                        </div>



                        {(this.props.page?.showDatePicker || this.props.page?.extraSelect) && (
                            <div className="w-100" style={{ backgroundColor: '#f2f6f8', borderRadius: 8, padding: '10px 15px 10px 15px' }}>
                                <div className="w-100" style={{ marginTop: 5, marginBottom: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                    {this.props.page?.showDatePicker && (
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '23%', margin: '1%', maxWidth: 300, }}>
                                                <p className="text-smaller mb-1 px-1">Date From</p>
                                                <div style={{ padding: '2px 10px', borderRadius: 4, backgroundColor: '#fff' }}>
                                                    <DateInput startOrEnd={'start'} header={{ key: 'startDate', information: { placeholder: 'From ...' } }} changeValue={this.changeDate} data={this.state.startDate} />
                                                </div>
                                            </div>

                                            <div style={{ width: '23%', margin: '1%', maxWidth: 300, }}>
                                                <p className="text-smaller mb-1 px-1">Date To</p>
                                                <div style={{ padding: '2px 10px', borderRadius: 4, backgroundColor: '#fff' }}>
                                                    <DateInput startOrEnd={'end'} startDate={this.state.startDate ? this.state.startDate : (new Date).getTime()} header={{ key: "endDate", information: { placeholder: 'To ...' } }} changeValue={this.changeDate} data={this.state.endDate} />
                                                </div>
                                            </div>

                                            <div style={{ width: '23%', margin: '1%', maxWidth: 300, }}>
                                                <p className="text-smaller mb-1 px-1">Period</p>
                                                <div style={{ padding: '2px 10px', borderRadius: 4, backgroundColor: '#fff' }}>
                                                    <SelectInput header={{ key: 'timeType', information: { type: 'local', items: [{ value: 'day', title: 'day' }, { value: 'week', title: 'week' }, { value: 'month', title: 'month' }, { value: 'year', title: 'year' }] } }} changeValue={this.changeSelectValue} data={this.state.timeType} />
                                                </div>
                                            </div>

                                            <div style={{ width: '23%', margin: '1%', maxWidth: 300, }}>
                                                <p className="text-smaller mb-1 px-1">Chart Type</p>
                                                <div style={{ padding: '2px 10px', borderRadius: 4, backgroundColor: '#fff' }}>
                                                    <SelectInput header={{ key: 'chartType', information: { type: 'local', items: [{ value: 'bar', title: 'bar' }, { value: 'line', title: 'line' }] } }} changeValue={(key, value) => { this.setState({ chartType: value }) }} data={this.state.chartType} />
                                                </div>
                                            </div>
                                        </div>

                                    )}

                                    {this.props.page?.extraSelect && (
                                        <div style={{ width: '23%', margin: '1%', maxWidth: 300, }}>
                                            <p className="text-smaller mb-1 px-1">Type</p>
                                            <div style={{ padding: '2px 10px', borderRadius: 4, backgroundColor: '#fff' }}>
                                                <SelectInput header={{ key: 'extra', information: { type: 'local', items: this.props.page.extraSelect } }} headerkey={"extra"} changeValue={this.extraSelectChange} data={this.state.filter?.extra} />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="w-100 flexcc mb-2">
                                    <button onClick={() => { this.doSearch() }} style={{ backgroundColor: '#000', borderRadius: 4, padding: '7px 15px 7px 15px', color: '#fff' }}><p className="text-normal">Search</p></button>
                                </div>

                            </div>
                        )}


                        {this.state.isLoading && (
                            <div className="p-5 flexcc text-center w-100">
                                <Loader
                                    type="Oval"
                                    color="#677dc4"
                                    height="70"
                                    width="70"
                                />
                            </div>
                        )}



                        {!this.state.isLoading && this.state.showTimeChart && this.state.showTimeChart && (
                            <div className="w-100" style={{ backgroundColor: '#fff', borderRadius: 8, padding: '20px 15px 20px 15px', marginBottom: 20 }}>
                                <div className="row text-center mt-4 W-100" style={{ paddingBottom: 0, alignItems: 'center' }}>

                                    <div className="col-12 w-100 p-0" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>

                                        {this.state.chartType == 'bar' && (
                                            <Bar
                                                data={this.state.chartData}
                                                options={this.state.lineChartOptions}
                                                ref={el => this.chart = el}
                                                height={120}
                                            />
                                        )}


                                        {this.state.chartType == 'line' && (
                                            <Line
                                                data={this.state.chartData}
                                                options={this.state.lineChartOptions}
                                                ref={el => this.chart = el}
                                                height={120}
                                            />
                                        )}

                                    </div>
                                </div>
                            </div>
                        )}



                        {!this.state.isLoading && this.state.showChart && this.props.page?.showHorizontalChart && (
                            <div className="w-100" style={{ backgroundColor: '#fff', borderRadius: 8, padding: '20px 15px 20px 15px', marginBottom: 20 }}>
                                <div className="row text-center mt-4 W-100" style={{ paddingBottom: 0, alignItems: 'center' }}>

                                    <div className="col-12 w-100" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>


                                        <HorizontalBar
                                            data={this.state.chartData}
                                            options={this.state.chartHorizontalOptions}
                                            ref={el => this.chart = el}
                                            height={this.state.data.reportSummery ? this.state.data.reportSummery.length * 10 : 'auto'}
                                        />

                                    </div>
                                </div>
                            </div>
                        )}


                    </div>
                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TimeGraphApplet);
